import React from "react";
import ReactDOM from "react-dom/client";
import {BrowserRouter} from "react-router-dom";
import "./index.css";
import App from "./App";
import {ChakraProvider, createSystem, defaultConfig} from "@chakra-ui/react";
import themeConfig from "./theme/theme";

const system = createSystem(defaultConfig, themeConfig);

console.log("System Configuration:", system); // Debugging

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <React.StrictMode>
        <ChakraProvider value={system}>
            <BrowserRouter>
                <App/>
            </BrowserRouter>
        </ChakraProvider>
    </React.StrictMode>
);
